import React from "react";

import UserIcon from "@src/assets/icons/profile.svg";
import "./employee_name.less";

interface EmployeeNameProps {
  name: string;
}

const EmployeeName: React.FC<EmployeeNameProps> = ({ name }) => {
  return (
    <div className="employee-name">
      <UserIcon data-testid="user-icon" />
      {name}
    </div>
  );
};

export default EmployeeName;
